var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "AutomationTemplatesLayout",
    {
      staticClass: "automation-template-sellsy",
      scopedSlots: _vm._u([
        {
          key: "header",
          fn: function() {
            return [
              _c("Heading", {
                attrs: {
                  labelTitle: _vm.translations.title,
                  showBackButton: true
                },
                on: {
                  "go-back": function($event) {
                    return _vm.$router.push({ name: "automations.listing" })
                  }
                }
              })
            ]
          },
          proxy: true
        },
        {
          key: "sidebar",
          fn: function() {
            return [
              _c("CompassInput", {
                staticClass: "automation-template-sellsy__search",
                attrs: {
                  prefixIcon: "search",
                  placeholder: _vm.$t.__(
                    "automation.AutomationTemplatesSellsy.placeholder_search"
                  ),
                  isEraseable: ""
                },
                model: {
                  value: _vm.searchTemplateValue,
                  callback: function($$v) {
                    _vm.searchTemplateValue = $$v
                  },
                  expression: "searchTemplateValue"
                }
              }),
              _vm._v(" "),
              _vm.tagsTemplates.length > 0
                ? [
                    _c(
                      "p",
                      {
                        staticClass:
                          "automation-template-sellsy__tags--title typographies-paragraph-small-semibold"
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.$t.__("common.labels.categories")) +
                            "\n            "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "automation-template-sellsy__tags" },
                      _vm._l(_vm.tagsTemplates, function(tag, index) {
                        return _c("CompassTagInteractive", {
                          key: tag.category,
                          attrs: {
                            modelValue: tag.label,
                            variant: "selectable",
                            color: "light-gray",
                            isSelected: tag.selected,
                            valueLabel: tag.label
                          },
                          on: {
                            change: function($event) {
                              return _vm.handleTagTemplates(index)
                            }
                          }
                        })
                      }),
                      1
                    )
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.isFiltered
                ? _c("CompassPlainButton", {
                    attrs: {
                      label: _vm.$t.__("common.actions.reset"),
                      leftIcon: "close"
                    },
                    on: { click: _vm.resetFilters }
                  })
                : _vm._e()
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._v(" "),
      _vm._v(" "),
      _c("InformationBanner", {
        staticClass: "automation-template-sellsy__banner",
        attrs: {
          title: _vm.translations.featureBanner.title,
          description: _vm.translations.featureBanner.description,
          sourceIllustration:
            "/ressources/logged/img/illustrations/banner-automation.svg",
          illustrationPosition: "left"
        }
      }),
      _vm._v(" "),
      _vm.filteredTemplates.length > 0 || _vm.isLoadingTemplates
        ? _c(
            "div",
            { staticClass: "automation-template-sellsy__container" },
            [
              _vm.isLoadingTemplates
                ? _vm._l(6, function(templateLoading) {
                    return _c("AutomationTemplateCard", {
                      key: templateLoading,
                      attrs: { template: {}, isLoading: "" }
                    })
                  })
                : _vm._l(_vm.filteredTemplates, function(template) {
                    return _c("AutomationTemplateCard", {
                      key: template.id,
                      attrs: { template: template }
                    })
                  })
            ],
            2
          )
        : _c("CompassEmptyState", {
            staticClass: "automation-template-sellsy__empty-state",
            attrs: {
              illustrationPath:
                "/ressources/logged/img/illustrations/no-results.svg",
              caption: _vm.translations.captionNoFilterResult
            }
          })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }